import type { FullRetentionBrandConfig } from "@/services/BrandConfigurationService";

export const FREE_SEARCH_TEXT_NAME = "freeSearchText";
export const FREE_SEARCH_MODE_NAME = "freeSearchMode";
export const FREE_SEARCH_FIELDS_NAME = "freeSearchFields";

export const ODATA_FILTER_GROUP_NAME = "odata";
export const RETENTION_FILTER_GROUP_NAME = "retention";

export interface CaseSearchResult extends Record<string, unknown> {
  "@search.score": number;
  id: string;
  caseReference: string;
}

export interface CaseSearchBody {
  searchText: string | undefined;
  searchMode: string | undefined;
  searchFields: string[] | undefined;
  filter: string | undefined;
  orderBy: string[] | undefined;
  select: string[] | undefined;
  lensCode: string;
  retentionFilter: NonNullable<FullRetentionBrandConfig["retentionFilters"]>[number]["key"] | "All";
  expiryDate: string | null;
}

export type CaseSearchFilterValue = {
  /** Used to specify collection fields. */
  isCollection: "true" | "false";
} & (
  | {
      type: "time-range" | "date-range";
      value: { from: string; to: string } | undefined;
    }
  | {
      type: "select";
      value: string | string[] | undefined;
      parseAs?: "string" | "literal";
    }
  | { type: "number"; value: number | undefined }
  | { type: "boolean"; value: "true" | "false" | undefined }
  | { type: "text"; value: string | undefined }
  | { type: "autocomplete"; value: string[] | undefined }
);

export type CaseSearchRawBody = Readonly<
  {
    [K in typeof ODATA_FILTER_GROUP_NAME | typeof RETENTION_FILTER_GROUP_NAME]:
      | Record<string, CaseSearchFilterValue>
      | undefined;
  } & {
    [K in typeof FREE_SEARCH_TEXT_NAME | typeof FREE_SEARCH_MODE_NAME | typeof FREE_SEARCH_FIELDS_NAME]:
      | string
      | undefined;
  }
>;

export type CaseSearchPersistedFilter = CaseSearchBody & { rawFilters: CaseSearchRawBody };
